import React, { useEffect, useState, useMemo } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getNovaPoshtaCities } from "../api/novaposhta";

const NovaPoshtaCitySelect = ({ value, onChange }) => {
  const { t } = useTranslation("common");
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchCities = async (search = "", pageNum = 1) => {
    setLoading(true);
    try {
      const res = await getNovaPoshtaCities(search, pageNum);
      const newOptions = pageNum === 1 ? res : [...options, ...res];
      setOptions(newOptions);
      setHasMore(res.length >= 50); // API returns max 50 items per page
    } catch (err) {
      console.error("Помилка завантаження міст:", err);
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = useMemo(() => {
    let timer;
    return (value) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setPage(1);
        fetchCities(value, 1);
      }, 500);
    };
    // fetchCities intentionally omitted — debounce factory should stay stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    debouncedSearch(inputValue);
  }, [inputValue, debouncedSearch]);

  const handleScroll = (event) => {
    const listboxNode = event.currentTarget;
    const bottomReached = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 5;
    if (bottomReached && hasMore && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchCities(inputValue, nextPage);
    }
  };

  return (
    <Autocomplete
      size="small"
      options={options.map((city) => city.Description)}
      value={value || ""}
      inputValue={inputValue}
      onInputChange={(_, val) => setInputValue(val)}
      onChange={(_, val) => onChange(val)}
      loading={loading}
      renderInput={(params) => (
        <TextField {...params} label={t("form.city")} variant="outlined" />
      )}
      ListboxProps={{
        onScroll: handleScroll,
        style: { maxHeight: 300, overflow: "auto" },
      }}
    />
  );
};

export default NovaPoshtaCitySelect;
